export default __webpack_public_path__ + "static/media/ic_macao.9033b1a3.svg";